import React, { useEffect, useState } from 'react';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../../CommonUtilities/CommonTable/CommonReactTable';
import Sweetalert from '../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import moment from 'moment';
import { MaskAadhaar } from '../../CommonUtilities/CommonFunctions/CommonFunction';
import { useSelector } from 'react-redux';


export const columns_not_mobile = [
  { Header: "S.NO", id: "sno", accessor: (row, index) => index + 1 },
  { Header: "Candidate ID", accessor: "candidate_id" },
  { Header: "Aadhaar", accessor: (row) => (<>{MaskAadhaar(row?.aadhaar_no)}</>) },
  { Header: "Candidate Name", accessor: "applicant_name" },
  { Header: "Father Name", accessor: "father_name" },
  {
    Header: "DOB",
    accessor: (row) => {
      if (!row?.dob) return "";
      const date = moment(row.dob, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY"], true);
      return date.isValid() ? date.format("DD/MM/YYYY") : row.dob;
    }
  },
  { Header: "Gender", accessor: "gender" },
  { Header: "PH", accessor: "ph" },
  {
    Header: "In Govt. Service?",
    accessor: (row) => (
      <>
        {row?.govemp}
        {row?.govemp === 'Yes' && <>({row?.management})</>}
      </>
    )
  },
  { Header: "Paper Applied", accessor: (row) => <>{row?.posts}</> },
];


const getDynamicColumns = (data, loginreducer, setMeritRowData, distDrill) => {
  if (!data || data.length === 0) return [];

  const ignoreKeys = ["dist_name", "dist_code", "tot_appl"];

  const postKeys = Object.keys(data[0]).filter(
    (key) => !ignoreKeys.includes(key)
  );

const commonCell = (key, label) => ({
  Header: (
    <div style={{ fontSize: "13px", textAlign: "center", lineHeight: "16px" }}>
      {label.split(" - ").map((part, index) => (
        <div key={index}>{part}</div>
      ))}
    </div>
  ),
  accessor: key,
  id: key,
  Cell: ({ row }) => (
    <button
      className={loginreducer?.role_id !== 7 ? 'btn btn-link p-0 m-0' : ''}
      style={{ fontSize: "12px", textAlign: "left" }}
      onClick={() => {
        if (loginreducer?.role_id !== 7) {
          if (row.original[key] > 0) {
            setMeritRowData(row?.original);
            distDrill(
              row?.original?.dist_code,
              key === "tot_appl" ? "T" : key
            );
          } else {
            Sweetalert("No Data Found", "warning");
          }
        }
      }}
    >
      {row.original[key]}
    </button>
  ),
  Footer: key,
  isClickable: loginreducer?.role_id !== 7,
  FooterFunc: () =>
    distDrill("0", key === "tot_appl" ? "T" : key),
});
  return [
    {
      Header: <div style={{ fontSize: "12px" }}>S.NO</div>,
      id: "sno",
      accessor: (row, index) => index + 1,
      Footer: "Total"
    },
    {
      Header: <div style={{ fontSize: "12px" }}>District Name</div>,
      accessor: "dist_name"
    },

    commonCell("tot_appl", "Total Applied"),

    {
      Header: <div style={{ fontSize: "12px" }}>Posts</div>,
      id: "posts_group", 
      columns: postKeys.map((key) => commonCell(key, key)),
    },
  ];
};

export default function TETDistPaperWiseReport() {
  const login_data = useSelector((state) => state.reducers.loginreducer.loginDetails);
  const loginreducer = login_data?.loginData;
  const [showDistData, setDistData] = useState([]);
  const [showDistDrill, setDistDrill] = useState([]);
  const [showMeritRowData, setMeritRowData] = useState();
  const [showD1, setD1] = useState();

  function getDistWisedata() {
    let Url = config.url.CONTEXT_READ_URL + "district-paper-wise-report";
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true && res?.data?.scode === "01") {
        setDistData(res?.data?.data);
        setD1(0);
      } else {
        setDistData([]);
      }
    });
  }

  function distDrill(distCode, paper) {
    let Url = config.url.CONTEXT_READ_URL + "district-paper-wise-report/drill?postId=" +
      paper + "&distCode=" + distCode;
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true && res?.data?.scode === "01") {
        setDistDrill(res?.data?.data);
        setD1(1);
      } else {
        setDistDrill([]);
        Sweetalert("No Data Found", "warning");
      }
    });
  }

  function isBackFunction() {
    setD1(showD1 - 1);
  }

  useEffect(() => {
    getDistWisedata();
  }, []);

  const distColumns = getDynamicColumns(
    showDistData,
    loginreducer,
    setMeritRowData,
    distDrill
  );

  return (
    <div>
      <CommonPageHeading heading="District Wise Papers Report" back={false} />
      {showD1 === 0 && (
        <>
          {showDistData?.length > 0 ? (
            <div className="table-responsive">
              <CommonReactTable
                tableid='selected-id'
                pagination="true"
                data={showDistData}
                columns={distColumns}
                serachAlign="left"
                isBack={false}
                headerName={<>Communication District Wise Papers Report</>}
                headColumCount={22}
                search="true"
                showFooter="true"
                filename="DistrictWiseReport"
                paginationCount="All"
              />
            </div>
          ) : (
            <div className="text-error text-center">*** No Data Found***</div>
          )}
        </>
      )}


      {showD1 === 1 && (
        <>
          {showDistDrill?.length > 0 ? (
            <div className="table-responsive">
              <CommonReactTable
                tableid='selected-id'
                pagination="true"
                data={showDistDrill}
                columns={columns_not_mobile}
                serachAlign="left"
                isBack={true}
                isBackFunction={isBackFunction}
                headerName={
                <>  TET Communication District Wise Papers Report
                    {showMeritRowData?.dist_name && (
                      <span style={{ color: "tomato" }}> - {showMeritRowData?.dist_name}
                      </span>
                    )}
                  </>
                }
                headColumCount={14}
                search="true"
                filename="DistrictWiseDrillReport"
              />
            </div>
          ) : (
            <div className="text-error text-center">*** No Data Found***</div>
          )}
        </>
      )}
    </div>
  );
}